import { fromJS } from 'immutable';

export default {
    setUsers: (state, users) => {
        return state.setIn(['list'], fromJS(users)).set('initialized', true);
    },
    updateHomeUsers: (state, homeUsers) => {
        return state.mergeDeepIn(['list'], fromJS(homeUsers));
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Users/core.js